import { getDeviceType } from "@/utils/device";
import { logger } from "./logger";

export enum FunnelFlow {
  Deposit = "deposit",
  Withdrawal = "withdrawal",
  Transfer = "transfer",
}

export enum FunnelStep {
  Intent = "intent",
  ExecuteClicked = "execute_clicked",
}

/**
 * Emit a transaction-funnel step.
 *
 * These logs are the source for the `pnx.transaction.funnel` log-based metric
 * (tags: flow, step, device, env), which captures the top of the funnel the
 * backend cannot see — the user reaching a payment form and clicking
 * the final submit — before the backend emits `initiated`.
 */
export const trackFunnelStep = (flow: FunnelFlow, step: FunnelStep) => {
  logger.info("transaction_funnel", {
    event: "transaction_funnel",
    flow,
    step,
    device: getDeviceType(),
  });
};
